import { HTMLResource } from '@lib/iab/iab-vast-model';

interface IHTMLResource {
    _value: string;
}

const createHTMLResource = ($htmlResource: IHTMLResource): HTMLResource => {
    const res = new HTMLResource();
    res.uri = $htmlResource._value;
    return res;
};

export default createHTMLResource;
